(function () {
  if (!/\/(policies|pages)\//.test(window.location.pathname)) return;

  document.addEventListener('DOMContentLoaded', function () {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var cfg      = window.__pzPageHero || {};
    var kicker   = cfg.kicker   || '';
    var subtitle = cfg.subtitle || '';

    /* Raccoglie il contenuto esistente */
    var originalContent = main.innerHTML;

    /* Estrae il titolo */
    var titleEl  = main.querySelector('h1, h2.page-title, .main-page-title');
    var titleText = titleEl ? titleEl.innerText.trim() : document.title;

    /* Kicker markup */
    var kickerHtml = kicker
      ? '<p class="pz-policy__hero-kicker">' + kicker + '</p>'
      : '';

    /* Subtitle markup */
    var subtitleHtml = subtitle
      ? '<p class="pz-policy__hero-subtitle">' + subtitle + '</p>'
      : '';

    /* Nuovo layout */
    var html = '<div class="pz-policy">'
      + '<div class="pz-policy__hero">'
      +   '<div class="pz-policy__hero-inner">'
      +     kickerHtml
      +     '<h1 class="pz-policy__title">' + titleText + '</h1>'
      +     subtitleHtml
      +   '</div>'
      + '</div>'
      + '<nav class="pz-policy__breadcrumb-bar" aria-label="Breadcrumb">'
      +   '<ol class="pz-policy__breadcrumb">'
      +     '<li><a href="/">Home</a></li>'
      +     '<li class="pz-policy__breadcrumb-sep" aria-hidden="true">·</li>'
      +     '<li>' + titleText + '</li>'
      +   '</ol>'
      + '</nav>'
      + '<div class="pz-policy__content">'
      +   '<div class="pz-policy__rte"></div>'
      + '</div>'
      + '</div>';

    main.innerHTML = html;

    /* Sposta il contenuto nella zona rte, rimuovendo il titolo duplicato */
    var rte = main.querySelector('.pz-policy__rte');
    var tmp = document.createElement('div');
    tmp.innerHTML = originalContent;
    var dupTitle = tmp.querySelector('h1, h2.page-title, .main-page-title');
    if (dupTitle) dupTitle.remove();
    rte.innerHTML = tmp.innerHTML;

    /* Carica il CSS se non già presente */
    if (!document.querySelector('link[href*="pz-policy"]')) {
      var link = document.createElement('link');
      link.rel  = 'stylesheet';
      link.href = window.__pzPolicyCss || '';
      if (link.href) document.head.appendChild(link);
    }
  });
})();
